<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('registers.lecturers.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('personalData') }}</div>
                </div>
                <div class="card-body">
                    <person :person="lector.person"
                            :show-extended="true"></person>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.livingAddress') }}</div>
                </div>
                <div class="card-body">
                    <app-address :address="lector.livingAddress"></app-address>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.teachingData') }}</div>
                </div>
                <div class="card-body row">
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'thematicArea' + _uid">
                            {{
                            $t('registers.lectors.thematicArea')
                            }}
                        </label>
                        <dynamic-multi-select :api-url="`/api/Dropdown/GetThematicAreas`"
                                            v-validate="'required'"
                                            v-model="lector.thematicAreaIds"
                                            :name="'registers.lectors.thematicArea' + _uid"
                                            :readonly="true"
                                            :data-vv-as="$t('registers.lectors.thematicArea')"
                                            :fieldName="$t('registers.lectors.thematicArea')"></dynamic-multi-select>
                        <!--                    <input type="text" class="form-control" v-model="lector.thematicArea" readonly>-->
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'themes' + _uid">{{ $t('registers.lectors.themes') }}</label>
                        <dynamic-multi-select :api-url="`/api/Lectors/GetThemesForDropdown`"
                                            v-model="lector.themesIds"
                                            :readonly="true"
                                            :request-params="lector.thematicAreaIds"
                                            :fieldName="$t('registers.lectors.themes')"></dynamic-multi-select>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'lectorTrainings' + _uid">
                            {{
                            $t('registers.lectors.lectorsTeaching')
                            }}
                        </label>
                        <toggle v-model="lector.lectorsTeaching" :disabled="true"></toggle>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'universityTraining' + _uid">
                            {{
                            $t('registers.lectors.universityTeaching')
                            }}
                        </label>
                        <toggle v-model="lector.universityTeaching" :disabled="true"></toggle>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'universityTraining' + _uid">
                            {{
                            $t('registers.lectors.nipTeaching')
                            }}
                        </label>
                        <toggle v-model="lector.nipTeaching" :disabled="true"></toggle>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'teachingPractitioners' + _uid">
                            {{
                            $t('registers.lectors.practitionersTeaching')
                            }}
                        </label>
                        <toggle v-model="lector.practitionersTeaching" :disabled="true"></toggle>
                    </div>
                    <div class="form-group col-lg-6">
                        <label :for="'status' + _uid" class="font-weight-bold">{{ $t('registers.lectors.status') }}</label>
                        <input type="text" class="form-control" v-model="lector.lectorStatus" readonly>
                    </div>
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'notes' + _uid">{{ $t('registers.lectors.notes') }}</label>
                        <textarea class="form-control" :id="'notes' + _uid" v-model="lector.notes" readonly></textarea>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.reasonForJoiningLikeLector') }}</div>
                </div>
                <div class="card-body row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'basisForInclusion' + _uid">
                            {{
                            $t('registers.lectors.reasonForJoining')
                            }}
                        </label>
                        <input type="text" class="form-control" v-model="lector.reasonForJoiningAsTeacher" readonly>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'managementBoardDecision' + _uid">
                            {{
                            $t('registers.lectors.decision')
                            }}
                        </label>
                        <input type="text" class="form-control" v-model="lector.decisionForJoining" readonly>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'decisionDate' + _uid">
                            {{
                            $t('registers.lectors.decisionDate')
                            }}
                        </label>
                        <datepicker v-model="lector.decisionForJoiningDate"></datepicker>
                    </div>
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'additionalInfo' + _uid">
                            {{
                            $t('registers.lectors.additionalInfo')
                            }}
                        </label>
                        <input type="text" class="form-control" v-model="lector.additionalInfoForJoining" readonly>
                    </div>
                    <!--                <div class="form-group col-lg-6">
                        <label :for="'contractSubject' + _uid" class="font-weight-bold">Предмет на договора</label>
                        <input type="text" class="form-control" :id="'contractSibject' + _uid">
                    </div>-->
                    <!--<div class="form-group col-lg-6">
                    <label :for="'contractPreparedBy' + _uid" class="font-weight-bold">Изготвил договора</label>
                    // TODO:
                </div>
                <div class="form-group col-lg-6">
                    <label :for="'contractTime' + _uid" class="font-weight-bold">Срок на договора</label>
                    // TODO:
                </div>-->
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.reasonForReleaseLikeTeacher') }}</div>
                </div>
                <div class="card-body row">
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'basisForInclusion' + _uid">
                            {{
                            $t('registers.lectors.reasonForRelease')
                            }}
                        </label>
                        <input type="text" class="form-control" v-model="lector.reasonForReleaseOfTeacherId" readonly>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'managementBoardDecision' + _uid">
                            {{
                            $t('registers.lectors.decision')
                            }}
                        </label>
                        <input type="text" class="form-control" v-model="lector.decisionForRelease" readonly>
                    </div>
                    <div class="form-group col-lg-6">
                        <label class="font-weight-bold" :for="'decisionDate' + _uid">
                            {{
                            $t('registers.lectors.decisionDate')
                            }}
                        </label>
                        <datepicker v-model="lector.decisionForReleaseDate"></datepicker>
                    </div>
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'additionalInfo' + _uid">
                            {{
                            $t('registers.lectors.additionalInfo')
                            }}
                        </label>
                        <input type="text" class="form-control" v-model="lector.additionalInfoForRelease" readonly>
                    </div>
                    <!--                <div class="form-group col-lg-6">
                        <label :for="'contractSubject' + _uid" class="font-weight-bold">Предмет на договора</label>
                        <input type="text" class="form-control" :id="'contractSibject' + _uid">
                    </div>-->
                    <!--<div class="form-group col-lg-6">
                    <label :for="'contractPreparedBy' + _uid" class="font-weight-bold">Изготвил договора</label>
                    // TODO:
                </div>
                <div class="form-group col-lg-6">
                    <label :for="'contractTime' + _uid" class="font-weight-bold">Срок на договора</label>
                    // TODO:
                </div>-->
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="h5">{{ $t('registers.lectors.cv') }}</div>
                </div>
                <div class="card-body">
                    <div class="card-body k-display-flex" v-if="lector.cvDetails.name != ''">
                        <file-download :file="lector.cvDetails"
                                       class="col-12"
                                       :type="lector.cvDetails.docTypeCode">
                        </file-download>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.attachedDocuments') }}</div>
                </div>
                <div class="card-body">
                    <div v-for="(document,index) in lector.documents" class="mt-2 border border-light-2 p-2 k-display-flex" :key="index">
                        <file-download :file="document"
                                       class="col-12"
                                       :type="document.docTypeCode">
                        </file-download>
                    </div>
                </div>
            </div>
            <div class="mt-3" v-if="lector">
                <AuxiliaryRegisterDetails :entryId="lector.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
            <div class="card mt-3" v-if="id">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.contractData') }}</div>
                </div>
                <div>
                    <contracts-list-grid ref="lecturerContracts" :lecturerId="Number(id)"></contracts-list-grid>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('eventDocuments.title') }}</div>
                </div>
                <div v-if="showEventDocs">
                    <lecturer-event-docs ref="lecturerEventDocs" :lecturerId="Number(id)"></lecturer-event-docs>
                </div>
            </div>
            <div class="card mt-3" v-if="id">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.lectors.eventsParticipation') }}</div>
                </div>
                <div>
                    <events-participation ref="lecturerEventParticipation" :lecturerId="Number(id)"></events-participation>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PersonComponent from '../../../components/person/PersonDetails';
    import FileDownload from '../../../components/common/FileDownload';
    import { LectorDetails, InstitutionDetails } from '../../../models/models'
    import DatePicker from '../../../components/datepicker/DatePickerDetails';
    import Toggle from '../../../components/toggle/Toggle';
    import Address from '../../../components/address/AddressDetails'
    import ParticipationEventDocs from '../../../components/docs/ParticipationEventDocs';
    import EventParticipation from '../lectors/LectorsParticipationGrid';
    import ContractsListGrid from "../externalSupplier/ContractsGrid";
    import DynamicMultiSelect from '../../../components/dropdown/DynamicMultiSelect';
    import AuxiliaryRegisterDetails from '../../../components/dynamic/AuxiliaryRegisterDetails'
    import PageTitle from '../../../components/common/PageTitle';

    export default {
        components: {
            Toggle,
            DynamicMultiSelect,
            'person': PersonComponent,
            'datepicker': DatePicker,
            'file-download': FileDownload,
            'app-address': Address,
            'lecturer-event-docs': ParticipationEventDocs,
            'events-participation': EventParticipation,
            'contracts-list-grid': ContractsListGrid,
            AuxiliaryRegisterDetails,
            PageTitle
        },
        data() {
            return {
                id: '',
                lector: new LectorDetails(),
                showCV: true,
                institution: new InstitutionDetails(),
                loading: false,
                showEventDocs: false,
            }
        },
        methods: {
            backToRegister() {
                this.$router.back();
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/Lectors/GetDetails/${this.id}`).then(result => {
                    this.lector = new LectorDetails(result.data);
                    if (this.lector.cvDetails.name !== '') {
                        this.showCV = false
                    }
                    this.showEventDocs = true;
                }).catch(error => {
                    // TODO:
                }).then(() => { this.loading = false; });
            }
        },
        watch: {
            'lector.institutionId'(newVal, oldVal) {
                if (this.lector.institutionId !== undefined
                    && this.lector.institutionId !== '' &&
                    this.lector.institutionId != null) {
                    this.$http.get(`/api/Institution/GetDetails/${this.lector.institutionId}`).then(result => {
                        this.institution = new InstitutionDetails(result.data);
                    });
                }
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
